export type CachedSyncStatus = 'in_sync' | 'qlik_ahead' | 'git_ahead' | 'auto_merge' | 'conflict';

export interface CachedSyncSummary {
  appId: string;
  status: CachedSyncStatus;
  baselineCommit?: string;
  qlikChangeCount: number;
  gitChangeCount: number;
  conflictCount: number;
  comparedAt: string;
}

const keyFor = (appId: string) => `click-ci:sync-summary:${appId}`;

export const readSyncSummary = (appId: string): CachedSyncSummary | undefined => {
  try {
    const raw = window.sessionStorage.getItem(keyFor(appId));
    return raw ? JSON.parse(raw) as CachedSyncSummary : undefined;
  } catch {
    return undefined;
  }
};

export const saveSyncSummary = (summary: CachedSyncSummary) => {
  window.sessionStorage.setItem(keyFor(summary.appId), JSON.stringify(summary));
};

export const syncSummaryLabel = (summary: CachedSyncSummary) => {
  if (summary.status === 'conflict') return `${summary.conflictCount} conflict${summary.conflictCount === 1 ? '' : 's'} require resolution`;
  if (summary.status === 'auto_merge') return 'Qlik and Git both have updates - review required';
  if (summary.status === 'git_ahead') return `Git has ${summary.gitChangeCount || 1} update${summary.gitChangeCount === 1 ? '' : 's'} ready to pull`;
  if (summary.status === 'qlik_ahead') return `Qlik has ${summary.qlikChangeCount} update${summary.qlikChangeCount === 1 ? '' : 's'} ready to push`;
  return 'Up to date';
};
